

declare var gGDPR_NonTCFVendors: object[];  // external variable in site layout file...

import { Emit, Component, Prop, Vue } from 'vue-facing-decorator';
import ToggleButton from './ToggleButton.vue';
import { Vue3SlideUpDown } from "vue3-slide-up-down";
import ChevronIcon from '../icons/ChevronIcon.vue'


// import {Vendor} from '@iabtechlabtcf/core'

// Vendor type not exported (WTF???) so we have to define it here
interface IntMap<T> {
    [id: string]: T;
}

interface DataRetention {
    stdRetention?: number;
    purposes: IntMap<number>;
    specialPurposes: IntMap<number>;
}

interface VendorUrl {
    langId: string;
    privacy: string;
    legIntClaim: string;
}

type Vendor = {
  id: number;
  name: string;
  purposes: number[];
    legIntPurposes: number[];
    flexiblePurposes: number[];
    specialPurposes: number[];
    features: number[];
    specialFeatures: number[];
    policyUrl?: string;
    usesCookies: boolean;
    cookieMaxAgeSeconds: number | null;
    cookieRefresh: boolean;
    usesNonCookieAccess: boolean;
    deviceStorageDisclosureUrl?: string;
    deletedDate?: Date | string;
    overflow?: {
        httpGetLimit: 32 | 128;
    };
    dataRetention?: DataRetention;
    urls?: VendorUrl[];
    dataDeclaration?: number[];
};


@Component({
  components: {
    ToggleButton,
    Vue3SlideUpDown,
    ChevronIcon
  },
})

export default class NonTCFVendorItem extends Vue {

    consent = false;
    expanded = false;
    collapseClass = "collapseButton collapseButtonRotatedUp"

    @Prop( { default:{ name:'none'} }) vendor!: Vendor;

    mounted() : void {

      for ( let modelVendor  in gGDPR_NonTCFVendors) {
      // @ts-ignore
        if ( gGDPR_NonTCFVendors[modelVendor].id == this.vendor.id ) {
        // @ts-ignore
          this.consent = gGDPR_NonTCFVendors[modelVendor].modelConsent;
        }
      }

      // TODO: Make sure code above sets initial value when recovering consent (set modelConsent = consent somewhere...)

    }

    @Emit('modelChangeEvent')
    changeConsent( value: object, srcEvent: any ) : void {

      // @ts-ignore
      let model = window.__cmpTCModel;

    // @ts-ignore
      if ( value.value )
        model.vendorConsents.set( this.vendor.id );
      else
        model.vendorConsents.unset( this.vendor.id );

    // @ts-ignore
      this.consent = value.value;

      // TODO: Emit dirty event here to enable button/save
      // this.$emit('modelChangeEvent', true );

      for ( let modelVendor  in gGDPR_NonTCFVendors) {
      // @ts-ignore
        if ( gGDPR_NonTCFVendors[modelVendor].id == this.vendor.id ) {
        // @ts-ignore
          gGDPR_NonTCFVendors[modelVendor].modelConsent = this.consent;
        }
      }
    // @ts-ignore
      this.consent = value.value;

      // this.$emit('modelChangeEvent', true );

    }


    expandCollapseClick() {
      if ( ! this.expanded )
        this.collapseClass = 'collapseButton collapseButtonRotatedDown';
      else
        this.collapseClass = 'collapseButton collapseButtonRotatedUp';
      this.expanded = ! this.expanded;
    }

}

